module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/step1.fc2b92c.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/step1.svg
// module id = HIKq
// module chunks = 0